import styled, { css } from 'styled-components';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { gray, grayLight, grayDarker } from '@bufferapp/ui/style/colors';
import { fontFamily } from '@bufferapp/ui/style/fonts';

export const DropdownMenuTrigger = styled(DropdownMenu.Trigger)`
  border: none;
  background: transparent;
`;

export const DropdownMenuContent = styled(DropdownMenu.Content)`
  width: 200px;
  padding: 0px;
  background: #ffffff;
  border: 1px solid ${grayLight};
  box-shadow: 4px 4px 20px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  z-index: 5000;

  & > * {
    border-bottom: 1px solid ${grayLight};
  }

  & > :last-child {
    border-bottom: none;
  }
`;

export const ActionsGroup = styled.div`
  padding: 4px;
`;

export const DropdownMenuItem = styled(DropdownMenu.Item)<{
  disabled: boolean;
}>`
  button {
    ${(props) =>
      props.disabled
        ? css`
            color: ${gray};
            cursor: not-allowed;
          `
        : css`
            color: ${grayDarker};
            cursor: pointer;
          `}
  }

  &[data-highlighted] {
    outline: none;
  }

  &[data-highlighted] > button {
    background: ${(props) => (props.disabled ? 'none' : '#e0e0e0')};
    border-radius: 4px;
  }
`;

export const Action = styled.button<{ flip?: boolean }>`
  font-family: ${fontFamily};
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  padding: 8px;
  display: flex;
  align-items: center;
  width: 100%;
  background: none;
  border: none;

  svg {
    margin-right: 8px;
    ${(props) => props.flip && 'transform: scale(-1, 1)'};
  }
`;
